// extracted by mini-css-extract-plugin
export default {"timeSlot":"TimeSlotButton_timeSlot__n9-Ce"};